import PasswordResetDialog from "./PasswordResetDialog.vue";

export default PasswordResetDialog;
